import BaseDateRangeField from './BaseDateRangeField';

export default BaseDateRangeField;
